import { PayloadAction } from '@reduxjs/toolkit'
import omit from 'lodash/omit'
import {
  BoughServiceByTimeSchedule,
  ReservationIdentifier,
} from '@/models/quote'
import { Service } from '@/models/service'
import { CartSliceState } from '../type'

interface Payload {
  service: Service
  boughtTimeSchedules: BoughServiceByTimeSchedule
  reservation: ReservationIdentifier
}

export function addTimeScheduleToCart(
  state: CartSliceState,
  action: PayloadAction<Payload>
) {
  const foundReservation = state.cartReservations.find(
    (r) =>
      r.spotName === action.payload.reservation.spotName &&
      r.spotType === action.payload.reservation.spotType
  )
  if (!foundReservation) {
    return
  }

  const { payload } = action

  if (Object.keys(payload.boughtTimeSchedules).length === 0) {
    // remove from cart
    const newBoughtServices = omit(foundReservation.boughtServices, [
      payload.service.serviceId,
    ])

    state.cartReservations = state.cartReservations.map((cr) => {
      if (cr !== foundReservation) {
        return cr
      }

      return {
        ...foundReservation,
        boughtServices: newBoughtServices,
      }
    })

    return
  }

  state.cartReservations = state.cartReservations.map((cr) => {
    if (cr !== foundReservation) {
      return cr
    }

    return {
      ...foundReservation,
      boughtServices: {
        ...foundReservation.boughtServices,
        [payload.service.serviceId]: payload.boughtTimeSchedules,
      },
    }
  })
}
